import { parseStyle, mobile, tablet } from "../../../juntion";

function Blank({ id, db, gs, device }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    return (
        <div
            style={{
                width: "100%",
                height: input.height,
                maxWidth: "100%",
            }}
        ></div>
    );
}

export default Blank;
